import { useGetContactsHistoriesCountQuery } from 'services';
import { FindAllContactHistoryDto } from 'types';

export function useContactHistoriesCount(queryParams: FindAllContactHistoryDto) {
  const { data: contactRes, isLoading } = useGetContactsHistoriesCountQuery(queryParams, {
    skip: !queryParams,
    refetchOnMountOrArgChange: true
  });

  return {
    count: contactRes?.data ?? 0,
    isLoading
  };
}
